<template>
  <div>
    <div style="padding: 15px;">
      <a-input :allowClear="true" style="width: 240px; margin-right: 15px;" placeholder="Order No." v-model="form.orderNo"/>
      <a-input :allowClear="true" style="width: 240px; margin-right: 15px;" placeholder="Phone" v-model="form.mobileNo"/>
      <a-button type="primary" @click="search()">{{ $t('search') }}</a-button>
    </div>
    <a-table
      :dataSource="list"
      :pagination="false"
      :loading="loading"
      :scroll = "{x: 1500}"
      rowKey="orderInfoId"
      bordered
      @change="handleTableChange">
      <a-table-column
        title="Order No."
        dataIndex="orderNo"
        key="orderNo"
        align="center"
      />
      <a-table-column
        title="CustomerPhone"
        dataIndex="custMobileNo"
        key="custMobileNo"
        align="center"
      />
      <a-table-column
        title="Due Repayment Amount"
        dataIndex="capital"
        key="capital"
        align="center"
      />
      <a-table-column
        title="alreadyAlsoAmount"
        dataIndex="settledCapital"
        key="settledCapital"
        align="center"
      />
      <a-table-column
        title="Due Repayment Interest"
        dataIndex="interest"
        key="interest"
        align="center"
      />
      <a-table-column
        title="alreadyAlsoInterest"
        dataIndex="settledInterest"
        key="settledInterest"
        align="center"
      />
      <a-table-column
        title="late fee"
        dataIndex="lateFee"
        key="lateFee"
        align="center"
      />
      <a-table-column
      title="Deduction Amount"
      dataIndex="deductionFee"
      key="deductionFee"
      align="center"
      />
      <a-table-column
        title="First Position Name"
        dataIndex="firstName"
        key="firstName"
        align="center"
      />
      <a-table-column
        title=" in PositionName"
        dataIndex="secondName"
        key="secondName"
        align="center"
      />
      <a-table-column
        title="AfterPositionName"
        dataIndex="lastName"
        key="lastName"
        align="center"
      />
      <a-table-column
        title="Audit Status"
        dataIndex="status"
        key="status"
        align="center"
      >
        <template slot-scope="text, record">
          <span>{{ text == 0 ? 'notReview' : 'alreadyReview' }}</span>
        </template>
      </a-table-column>
      <a-table-column
        :title="$t('platformCollection.operation')"
        dataIndex="action"
        key="action"
        align="center"
      >
        <template slot-scope="text, record">
              <span>
                  <a href="javascript:;" @click="createGroup( record.orderInfoId)">Review</a>
              </span>
        </template>
      </a-table-column>
    </a-table>
    <create-group-modal ref="createGroupModal" @refresh="handleTableChange"/>
  </div>
</template>
<script>
  import CreateGroupModal from "@/views/webpublic/platformCollection/modules/CreateGroupModal";
  import {getOrderImageList,} from '@/webpublicapi/orderImageInfo'

  export default {
    components:{CreateGroupModal},
    data () {
      return {
        loading: false,
        form: {
          orderNo: undefined,
          mobileNo: undefined,

        },
        list: [],
      }
    },
    computed: {

    },
    created () {
      this.search();
      getOrderImageList().then(res => {
        this.userList = res.data || [];
      });
    },
    methods: {
      createGroup(id){
        this.$refs.createGroupModal.show(id);
      },
      handleTableChange () {
        this.search();
      },
      search () {
        this.loading = true;
        getOrderImageList(this.form).then(res => {
          this.loading = false;
          this.list = res && res.data && res.data.rows;
          this.total = res && res.data && res.data.total;
        }).catch(e => {
          this.loading = false;
          this.$message.error(e.message);
        });
      },
    }
  }
</script>
